/* eslint-disable */
// Custom month grid for the Upcoming tab's calendar view. Plain CSS grid —
// 7 columns Mon–Sun, prev/next arrows, up to 3 colored dots per day
// (community / hosting / invited), today highlighted. Clicking a day tells
// the parent, which renders that day's events beneath the grid.
import { useMemo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { toYmd } from "./dateTimePickers";
import "./MonthCalendar.css";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
// Dot order is fixed so colors are stable: community, hosting, invited.
const KIND_ORDER = ["community", "hosting", "invited"];

export default function MonthCalendar({ month, onMonthChange, items, selectedDate, onSelectDay }) {
  const y = month.getFullYear();
  const m = month.getMonth();

  const kindsByDay = useMemo(() => {
    const map = {};
    for (const it of items || []) {
      if (!it.event_date) continue;
      (map[it.event_date] = map[it.event_date] || new Set()).add(it.kind);
    }
    return map;
  }, [items]);

  const cells = useMemo(() => {
    const first = new Date(y, m, 1);
    const lead = (first.getDay() + 6) % 7; // Monday-first offset
    const daysInMonth = new Date(y, m + 1, 0).getDate();
    const out = [];
    for (let i = 0; i < lead; i++) out.push(null);
    for (let d = 1; d <= daysInMonth; d++) out.push(new Date(y, m, d));
    return out;
  }, [y, m]);

  const todayYmd = toYmd(new Date());
  const monthLabel = month.toLocaleString("en-IN", { month: "long", year: "numeric" });

  return (
    <div className="vs-cal">
      <div className="vs-cal-head">
        <button
          type="button"
          className="vs-cal-nav"
          aria-label="Previous month"
          onClick={() => onMonthChange(new Date(y, m - 1, 1))}
        >
          <ChevronLeft size={18} />
        </button>
        <span className="vs-cal-title">{monthLabel}</span>
        <button
          type="button"
          className="vs-cal-nav"
          aria-label="Next month"
          onClick={() => onMonthChange(new Date(y, m + 1, 1))}
        >
          <ChevronRight size={18} />
        </button>
      </div>

      <div className="vs-cal-grid">
        {WEEKDAYS.map((w) => (
          <div key={w} className="vs-cal-weekday">{w}</div>
        ))}
        {cells.map((d, i) => {
          if (!d) return <div key={`b${i}`} className="vs-cal-cell vs-cal-blank" />;
          const ymd = toYmd(d);
          const kinds = kindsByDay[ymd];
          const classes = [
            "vs-cal-cell",
            ymd === todayYmd ? "vs-cal-today" : "",
            ymd === selectedDate ? "vs-cal-selected" : "",
            kinds ? "vs-cal-has-events" : "",
          ].filter(Boolean).join(" ");
          return (
            <button key={ymd} type="button" className={classes} onClick={() => onSelectDay(ymd)}>
              <span className="vs-cal-daynum">{d.getDate()}</span>
              <span className="vs-cal-dots">
                {KIND_ORDER.filter((k) => kinds?.has(k)).map((k) => (
                  <span key={k} className={`vs-cal-dot vs-cal-dot-${k}`} />
                ))}
              </span>
            </button>
          );
        })}
      </div>

      <div className="vs-cal-legend">
        <span><span className="vs-cal-dot vs-cal-dot-community" /> Community</span>
        <span><span className="vs-cal-dot vs-cal-dot-hosting" /> Hosting</span>
        <span><span className="vs-cal-dot vs-cal-dot-invited" /> Invited</span>
      </div>
    </div>
  );
}
